import { s as r } from "../index.esm-DOxVcNnO.js";
import { styled as n } from "styled-components";
import { compose as e, border as p, layout as i, color as t, space as c, position as s } from "styled-system";
import l from "../common/themes/whiteLabel/componentStyles/iconStyles.mjs";
import a from "../common/themes/whiteLabel/componentStyles/loadingSpinnerStyles.mjs";
import d from "../common/themes/whiteLabel/componentStyles/visuallyHiddenStyles.mjs";
const w = /* @__PURE__ */ n.div.withConfig({
  shouldForwardProp: (o) => r(o)
}).withConfig({
  componentId: "sc-4139e7e6-0"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.loadingSpinner.circle, e(p)), F = /* @__PURE__ */ n.div.withConfig({
  shouldForwardProp: (o) => r(o)
}).withConfig({
  componentId: "sc-4139e7e6-1"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.loadingSpinner.wrapper, e(i, t)), b = /* @__PURE__ */ n.div.withConfig({
  shouldForwardProp: (o) => r(o)
}).attrs(({ active: o }) => ({
  "aria-busy": o,
  role: "alert",
  "aria-live": "polite"
})).withConfig({
  componentId: "sc-4139e7e6-2"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.loadingSpinner.bg, e(c, s, i, t)), v = /* @__PURE__ */ n.div.withConfig({
  componentId: "sc-4139e7e6-3"
})([
  "",
  ""
], ({ theme: o }) => o.components.loadingSpinner.contentWrapper), S = {
  componentColors: {
    loadingSpinner: {
      circle: "#1C2640",
      bgSolid: "#FFFFFF",
      bgTranslucentBlur: "#CECFCD",
      bgTranslucentNoBlur: "#CECFCD"
    }
  },
  space: {
    sm: "1.6rem"
  },
  components: {
    loadingSpinner: a,
    icon: l,
    visuallyHidden: d
  }
};
export {
  b as BackgroundOverlay,
  w as Circle,
  F as CircleWrapper,
  v as ContentWrapper,
  S as blankTheme
};
